const columns = [
  {
    title: '排序',
    key: 'order',
    width: 200
  },
  {
    title: 'AppName',
    key: 'appName',
  },
  {
    title: '名称',
    key: 'title',
    width: 200,
  },
  {
    title: '注册方式',
    width: 300,
    render: (h, params) => {
      let fromIP = params.row.addressType;
      let result = "--";
      result = fromIP === 0 ? '自动注册' : '手动录入'
      return h("div", result);
    },
  },
  {
    title: 'OnLine 机器地址',
    width: 300,
    render: (h, params) => {
      let fromIP = params.row.addressList || '--';
      return h("div", fromIP);
    },
  },
  {
    title: '操作',
    slot: 'iconfont',
    width: 100,
    iconClass: [
      { name: "ys-iconbianji", code: "编辑", status: 1, Pname: 'org_user_edit_btn' },
      { name: "ys-iconlajitongbeifen", code: "删除", status: 1, Pname: 'org_user_delete_btn' },
    ]
  },
]

export default columns